import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home/yxz.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-40024627")

_pushScopeId("data-v-40024627")
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = {
  target: "view_window",
  href: "https://gwsd-docs.oss-cn-shenzhen.aliyuncs.com/%E9%93%81%E9%80%9A%E7%AE%A1%E7%90%86%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E.pdf"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "imgyxz",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "mt-10" }
const _hoisted_5 = {
  target: "view_window",
  href: "http://www.poc-dispatch.com/login"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "imgyxz",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "mt-10" }
const _hoisted_8 = { href: "https://gwsd-docs.oss-cn-shenzhen.aliyuncs.com/%E5%86%99%E7%A0%81%E8%BD%AF%E4%BB%B6.zip" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "imgyxz",
  src: _imports_0,
  alt: ""
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("a", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.t("documentation.Management Platform Intercom Operation Instructions")) + " ", 1),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("a", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.t("documentation.Open the Dispatcher")) + " ", 1),
        _hoisted_6
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("a", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.t("document.coding software")) + " ", 1),
        _hoisted_9
      ])
    ])
  ]))
})